import { FC } from 'react'
import { Handle, NodeProps, Position } from '@xyflow/react'

import { GreyGrey30, Box } from '@sequencehq/core-components'
import { getNodeHandleId } from 'Automations/nodeDefinitions/helpers/nodeHandleId'
import {
  CONNECTION_PREVIEW_SKELETON_HEIGHT,
  CONNECTION_PREVIEW_SKELETON_WIDTH
} from './connectionPreview.constants'

export {
  CONNECTION_PREVIEW_NODE_ID,
  CONNECTION_PREVIEW_NODE_TYPE
} from './connectionPreview.constants'

/**
 * The skeleton ghost shown while a connection is dropped on empty canvas and no
 * picker option is hovered yet: a plain fixed-size rectangle. Once an option is
 * hovered the canvas renders the real node instead.
 */
export const ConnectionPreviewNode: FC<NodeProps> = ({ id }) => {
  return (
    <Box
      data-testid="automations.editor.connectionDrop.skeleton"
      width={`${CONNECTION_PREVIEW_SKELETON_WIDTH}px`}
      height={`${CONNECTION_PREVIEW_SKELETON_HEIGHT}px`}
      borderRadius="12px"
      backgroundColor={GreyGrey30}
      pointerEvents="none"
    >
      <Handle
        type="target"
        position={Position.Left}
        id={getNodeHandleId({ nodeId: id, type: 'target' })}
        isConnectable={false}
        style={{ opacity: 0 }}
      />
    </Box>
  )
}
